import {Injectable} from "@angular/core";
import {ProductionEnvironment} from "../../../../common/environment";

@Injectable()
export class AppEnvironment extends ProductionEnvironment {
    spa = "Management Portal";
}

export const environment = new AppEnvironment();
